/**
 * Builds a user-friendly delivery type label
 * @param {Object} sale Sale document
 * @returns User-friendly delivery type label
 */
export const getDeliverTypeLabel = sale => {
    let type = ''
    switch (sale.type) {
        case 'ONLINE_PAYMENT__DELIVERY':
            type = `Delivery a ${sale.address}`
            break

        case 'ONLINE_PAYMENT__PICKUP':
            type = 'Retira en el local'
            break

        case 'ONSITE_PAYMENT__DELIVERY':
            type = `Delivery a ${sale.address}`
            break

        case 'ONSITE_PAYMENT__PICKUP':
            type = 'Retira en el local'
            break

        default:
            break
    }
    return type
}

/**
 * Builds a user-friendly payment type label
 * @param {Object} sale Sale document
 * @returns User-friendly payment type label
 */
export const getPaymentTypeLabel = sale => {
    let paymentType
    if (sale.paymentType === 'ONSITE') {
        paymentType = 'En la entrega'
    } else {
        paymentType = 'Online'
    }
    return paymentType
}

/**
 * Transforms an array of cart entries into an array of sale products.
 *
 * @param {Array} cartEntries - The array of cart entries.
 * @param {Object} cartEntries[].item - The item object in the cart entry.
 * @param {string} cartEntries[].item._id - The ID of the item.
 * @param {Object} cartEntries[].variant - The variant object in the cart entry.
 * @param {string} cartEntries[].variant._id - The ID of the variant.
 * @param {Array} cartEntries[].additionals - Additional items or options in the cart entry.
 * @param {number|string} cartEntries[].quantity - The quantity of the item in the cart entry.
 * @param {string} cartEntries[].notes - Any notes associated with the cart entry.
 * @returns {Array} An array of sale products with transformed properties.
 */
export const getSaleProductsFromCartEntries = cartEntries => {
    return cartEntries.map(cartEntry => ({
        master: cartEntry.item._id || cartEntry.item,
        variant: cartEntry.variant._id || cartEntry.variant,
        additionals: cartEntry.additionals,
        amount: Number(cartEntry.quantity),
        notes: cartEntry.notes,
    }))
}
